import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { ROOT_DIR, LOCATION, DOMAIN } from '../../utils/Constants';
import BackLink from '../pieces/BackLink';
import GeneralUtil from '../../utils/GeneralUtil';
import SmallLoader from '../pieces/SmallLoader';
import Client from '../../utils/Client';
import ModalMedium from '../blocks/ModalMedium';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import TextArea from 'react-validation/build/textarea';
import axios from 'axios';

/* global google */

const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return (<RequiredError/>);
  }
};
 
const email = (value) => {
  if (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
    return (<EmailError value={value}/>);
  } 
};
function loadJS(src) {
    var ref = window.document.getElementById('gtmgr');
    var script = window.document.createElement("script");
    script.src = src;
    script.async = true;
    ref.parentNode.insertBefore(script, ref);
}
function RequiredError(){
  return (
    <label className="error">This field is required.</label>
  )
}
function EmailError({...props}){
  return (
    <label className="error">{props.value} is not a valid email.</label>
  )
}

function Hours({...props}){
  return (
    props.hours ?
      props.hours.map((item, idx) => (
          <div className="day" key={idx} dangerouslySetInnerHTML={{ __html: item }}></div>
        ))
    :
    ''
  )
}
function Photos({...props}){
  //console.log(props);
  return (
    
     props.photos && props.photos.length > 0 ?
       <div>
        <div className="row">
          <div className="large-12 columns">
            <div className="bold details-heading">
              PHOTOS
            </div>
          </div>
        </div>
        <div className="row photos-wrapper">
        {props.photos.map((item, idx) => (

            <div key={idx} className={`medium-4 large-3 columns img-wrapper ${idx + 1 === props.photos.length ? ' end' : ''}`}>
                <img src={`${ROOT_DIR}/assets/img/photos/bus${props.id}/${item}.jpg`} />
            </div>
          ))}
        </div>
      </div>
      :
      ''
  )
}

class BusinessDetailPriority extends Component {
  state = {
    place: {},
    modalOpen: false,
    formSubmitted: false,
    formSent: false,
    errors: false
  }
 
  componentDidMount(){
    Client.getPriorityById(this.props.match.params.id, this.setBusiness);
  }
  toggleModal = (e) => {
    e.preventDefault();
    window.scrollTo(500, 0);
    this.setState({
      modalOpen: !this.state.modalOpen
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.form.validateAll();

    setTimeout(() => {
      window.scrollTo(500, 0);
      if(document.getElementsByClassName('is-invalid-input').length === 0){
        //this.setState({ errors: false })
        this.sendFormData();
      }
      else {
        this.setState({ errors: true })
      }
     
    }, 10);
  }
  sendFormData = () => {
    var form = document.getElementById('business-contact-form');
    var formArray = [];
    var formString = '';
    for(var i = 0; i < form.elements.length; i++ ){
      var obj = {};
      obj.name = form.elements[i].name;
      obj.value = form.elements[i].value;
      
      formArray.push(obj);
      formString += `${form.elements[i].name}=${form.elements[i].value}&`;
    }

    this.setState({
      formSubmitted: true
    });

    axios.post(`http://www.${DOMAIN}/contact_business.php?id=${this.state.place.id}&${formString}`)
      .then(function (response) {
        
        updateState();
      })
      .catch(function (error) {
        console.log(error);
      });

    var updateState = () => {
      this.setState({
        formSubmitted: false,
        formSent: true,
        errors: false
      });
    }
  }
  setBusiness = (obj) => {
    window.scrollTo(500, 0);
    this.setState({
      place: obj
    });
    // Connect the initMap() function within this class to the global window context,
    // so Google Maps can invoke it
    window.initMap = this.initMap;
    // Asynchronously load the Google Maps script, passing in the callback reference
    
    loadJS(`https://maps.googleapis.com/maps/api/js?key=AIzaSyDCgXBG7quJEvH9qMqEhbl7JNc1QBEB69E&libraries=places&callback=initMap`);
        
    
  }
  
  initMap = () => {
      let place = this.state.place;
      let zoom = 15;
      let address = place.address;
      let name = place.name;
      let center = {
        lat: place.lat,
        lng: place.lng
      }

      if(place.address1){
        address = place.address1;
      }
      if(place.name1){
        name = place.name1;
      }
      if(place.centerlat){
        center = {
          lat: place.centerlat,
          lng: place.centerlng
        }
      }
      if(place.zoom){
        zoom = place.zoom;
      }
      var map = new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: zoom
      });
      var infowindow = new google.maps.InfoWindow();

      var marker = new google.maps.Marker({
        map: map,
        position: {lat: place.lat, lng: place.lng}
      });
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.setContent('<div><strong>' + name + '</strong><br>' +
          address + '<br>');
        infowindow.open(map, this);
      });
      if(place.lat1) {
        var marker1 = new google.maps.Marker({
          map: map,
          position: {lat: place.lat1, lng: place.lng1}
        });
        google.maps.event.addListener(marker1, 'click', function() {
          infowindow.setContent('<div><strong>' + place.name2 + '</strong><br>' +
            place.address2 + '<br>');
          infowindow.open(map, this);
        });
      }
      if(place.lat2) {
        var marker2 = new google.maps.Marker({
          map: map,
          position: {lat: place.lat2, lng: place.lng2}
        });
         google.maps.event.addListener(marker2, 'click', function() {
          infowindow.setContent('<div><strong>' + place.name3 + '</strong><br>' +
            place.address3 + '<br>');
          infowindow.open(map, this);
        });
        
      }

      
      
      
      
  }
  handleError = () => {
    console.log('image error');
  }
  render(){
    
    let title = '';
    let place = this.state.place;
    let anysocial = false;
    let modalClass = '';
    let contactClass = '';
    if(!place.contactform){
      contactClass = 'no-contact';
    }
    if(this.state.modalOpen){
      modalClass = 'show';
    }

    const meta = {
      title: `― ${place.name} in ${LOCATION}, Essex ― find businesses, services, events and more in ${LOCATION}, Essex, UK in our business directory`,
      description: `${place.name} in ${LOCATION}. Find ${title}, businesses, services, events and more in ${LOCATION}, Essex, UK. Business directory for ${LOCATION}, Essex`,
      canonical: `http://www.basildon-online.com/pdetails/${this.props.match.params.id}`,
      meta: {
        keywords: `${place.name} on ${LOCATION}, Essex, ${LOCATION}, Essex, online, ${LOCATION} businesses, ${LOCATION} business directory, ${LOCATION} services, ${LOCATION} events, UK, United Kingdom`
      }
      
    };

    if(place.website || place.facebook || place.twitter) {
      anysocial = true;
    }
    
    return(
      <div>
        <DocumentMeta {...meta} />
        <ModalMedium
          title={place.name}
          modalClass={modalClass}
          toggleModal={this.toggleModal}
        >
          <div>
            {this.state.errors &&
              <p className="bold highlight"><label className="error">There were errors in this form. Please review and correct the indicated fields.</label></p>
            }
            
            {this.state.formSubmitted && 
            <SmallLoader/>
            }
            
            {!this.state.formSent &&
              <Form ref={c => { this.form = c }} noValidate="novalidate" id="business-contact-form" onSubmit={this.handleSubmit}> 
                <p>Contact <span className="bold">{place.name}</span> directly by completing the form below:</p>
                <div className="input-row">
                    <Input type="text" name="name" placeholder="Your name *" validations={[required]}/>
                </div>
                <div className="input-row">
                    <Input type="text" name="email" placeholder="Your email *" validations={[required, email]}/>
                </div>
                <div className="input-row">
                    <TextArea placeholder="Your message *" name="message" validations={[required]}></TextArea>
                </div>
                <div className="input-row">
                    <button type="submit">Send</button>
                </div>
              </Form>
            }

            { this.state.formSent &&
                <div className="form-success">
                  <h3 className="color">Thank you!</h3>
                  <p>Your message has been sent to {place.name}.</p>
                  <p><a href='#' onClick={this.toggleModal}>Close window</a></p>
                </div>
            }
          </div>
        </ModalMedium>
        <div ref="map" className="map-wrapper" id="map">
          <SmallLoader/>
        </div>
        


        <div className="row company-name-wrapper">
          <div className="large-12 columns company-name-col">
            <p className="text-xsmall g-map-link"><i className="fa fa-google" aria-hidden="true"></i> <a href='/' target="_blank"> View in Google Maps</a></p>

            <div className="priority-logo-wrapper">
              <a href="#"><img src={`${ROOT_DIR}/assets/img/logos/bus${place.id}.jpg`}/></a>
            </div>
            <div className="priority-info-wrapper">
              
              <h2 className={`company-name no-margin ${contactClass}`}>{place.name}</h2>
              <div className={`company-subheading ${contactClass}`} dangerouslySetInnerHTML={{ __html: place.description }}></div>
              
              {place.contactform &&
                <div className="contact">
                  <button className="button" onClick={this.toggleModal}>Contact now</button>
                </div>
              }
              
            </div>
          </div>
        </div>
        <div className="page-content-wrapper innerpage-details">
          <div className="row innerpage-contact-hours">
            <div className="medium-6 columns">
              <div className="innerpage-details-section">
                <div className="bold details-heading"><i className="fa fa-map-marker" aria-hidden="true"></i> ADDRESS</div>
                <div>{place.address}</div>
                <div>{place.city} {place.postal}</div>
              </div>
              { place.tel ? 
                <div className="innerpage-details-section">
                  <div className="bold details-heading"><i className="fa fa-phone" aria-hidden="true"></i> TEL</div>
                  <div>Phone: <a href={`tel:${place.tel}`} className="tel">{place.tel}</a></div>
                </div>
              :
              ''
              }
             
                <div className="innerpage-details-section">
                 
                { anysocial && 
                  <div className="bold details-heading"><i className="fa fa-globe" aria-hidden="true"></i> WEBSITE / SOCIAL </div>
                }
                { place.website && 
                  <div><a href={place.website} target="_blank">{place.website}</a></div>
                }
                  <div className="priority-social">
                    { place.facebook && 
                      <a href={place.facebook} className="social-facebook" target="_blank"><i className="fa fa-facebook-official fa-2x" aria-hidden="true"></i></a>
                    }
                    { place.twitter && 
                      <a href={place.twitter} className="social-twitter" target="_blank"><i className="fa fa-twitter-square fa-2x" aria-hidden="true"></i></a>
                    }
                  </div>
                </div>

              
            </div>

            <div className="medium-6 columns">
              <div className="innerpage-details-section">
                <div className="bold details-heading hours-heading">HOURS</div>
               
                {place.hours && place.hours.length > 0 ? 
                  <Hours hours={place.hours}/>
                :
                  <p>No opening hours information available.</p>
                }
          
                
              </div>
            </div>

          </div>
          <Photos photos={place.photos} id={place.id}/>

        </div>
      </div>
    );
  }
}

export default BusinessDetailPriority;


// WEBPACK FOOTER //
// ./src/components/pages/BusinessDetailPriority.js